// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/js/async/" + ({"354": "lib-axios","535": "lib-router",}[chunkId] || chunkId) + "." + {"125": "cf91006d","190": "9a248622","231": "9c0b7ca9","354": "7c32f337","535": "df1a9e93","677": "d77ed64e",}[chunkId] + ".js"
}